<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JBu3vR/tc-custom/9781497671751.jpg?1734036673183" alt="This image is the cover for the book Another Word for Murder, Crossword Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Another Word for Murder, Crossword Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Murder moves into the neighborhood in this witty and suspenseful crossword mystery featuring husband-and-wife sleuth team Belle Graham and Rosco Polycrates </b><br/><br/> Belle Graham and her canine bodyguards, Kit and Gabby, are enjoying their daily outing in the local dog park with new friends Karen Tacete, her daughter Lily, and their dog Bear. But Karen’s picture-perfect life shatters when her husband, Dan, fails to return home. He’s barely been declared officially missing when Karen receives a ransom note that includes a dire warning: If she contacts the police or the FBI, Dan dies.<br/><br/> Who would kidnap the popular dentist against whom no one ever had a cross word? That’s what Belle and her husband, PI Rosco Polycrates, need to find out. When the Tacete abduction escalates to murder, Belle and Rosco realize the solution may lie in the baffling nursery rhyme–themed crosswords Belle has been receiving. As they dig into the life of Newcastle’s most charitable DDS, they soon find themselves up to their eyeteeth in danger, racing to fill in the blanks of a plan orchestrated by someone out to make a killing.<br/><br/> This ebook includes six crossword puzzles that can be downloaded as PDFs, with answers in the back of the book.<br/><br/><b><i>Another Word for Murder </i></b><b>is the 7th book in the Crossword Mysteries, but you may enjoy reading the series in any order.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nero Blanc
      </h2>
      
      <p class="authorDescription body article">Nero Blanc is the pseudonym of Steve Zettler and Cordelia Frances Biddle, who are husband and wife and serious crossword buffs. Biddle is also the author of the Martha Beale historical mystery series, which is set in Philadelphia, Zettler and Biddle&rsquo;s hometown. Their website is www.crosswordmysteries.com.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3000eb16